import { useState } from 'react';

import ErrorComponent from '@/components/common/error-component/ErrorComponent';
import Telegram from '@/components/ui/icons/Telegram';
import { WidgetComponent } from '@/forms/components/widget';
import useEffectOnlyOnUpdate from '@/hooks/useEffectOnlyOnUpdate/useEffectOnlyOnUpdate';

import classes from './TextInput.module.scss';

const TextInput = ({
	label,
	name,
	placeholder,
	value,
	inputArgs,
	readOnly,
	disabled,
	onChange,
	required,
	autoFocus,
	resDataAfterSubmit,
	form,
	theme = 'shadow',
}: WidgetComponent) => {
	const elId = `id_${name}`;

	const [errorAfterSubmit, setErrorAfterSubmit] = useState<string[] | null>(
		null
	);

	useEffectOnlyOnUpdate(() => {
		if (resDataAfterSubmit) {
			const { errorMessage } = resDataAfterSubmit;
			if (Object.entries(errorMessage).length > 0) {
				// eslint-disable-next-line unicorn/no-lonely-if
				if (errorMessage[name]) setErrorAfterSubmit(errorMessage[name]);
			}
		}
	}, [resDataAfterSubmit]);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setErrorAfterSubmit(null);
		onChange(e.target.value);
	};
	const labelAndValue = form === 'projectEditForm';

	return (
		<section
			className={[
				classes.container,
				classes['container-' + theme],
				classes[name],
			].join(' ')}
			data-error={errorAfterSubmit ? true : undefined}
		>
			{labelAndValue ? (
				<label>
					<span>{label}</span>
					<span>{Number(value) ? `${value} ч.` : value?.toString()}</span>
				</label>
			) : (
				label && (
					<label htmlFor={elId}>
						{placeholder === 'Новый аккаунт' && (
							<Telegram clazz={`${classes.icon} ${classes['icon--fill']}`} />
						)}
						{label}
					</label>
				)
			)}
			{name !== 'spentTime' && (
				<input
					form={form}
					autoFocus={autoFocus}
					className={`${classes.input} ${classes['input-' + theme] || ''}`}
					placeholder={placeholder}
					name={name}
					id={elId}
					onChange={handleChange}
					disabled={disabled}
					readOnly={readOnly}
					required={required}
					defaultValue={!(value instanceof Date) && value ? value : ''}
					type='text'
					{...(inputArgs || {})}
				></input>
			)}
			{errorAfterSubmit?.map((i, idx) => {
				return (
					<ErrorComponent key={idx} clazz={classes.error}>
						{`*${i}`}
					</ErrorComponent>
				);
			})}
		</section>
	);
};

export default TextInput;
